import AuthService from '@services/auth.service';

export default ({ store }) => {
    if (!store.getters.isAuthorized) {
        AuthService.logout();
    }
};
